import moment from 'moment';
import { useEffect, useState } from "react";
import DeviceService from './Services/DeviceService';
import { IDM_SERVER_BASE_URL } from "./Constants";
import Popup from "./Components/PopupComponent/Popup";
import LoadingIndicator from "./Components/CommonComponent/LoadingIndicator";

export const API_URL = IDM_SERVER_BASE_URL + "/api";

function Home() {
    const [isLoading, setIsLoading] = useState(false);
    const [deviceList, setDeviceList] = useState([]);
    const [activatePopup, setActivatePopup] = useState(false);
    const [deActivatePopup, setDeactivatePopup] = useState(false);
    const [serialNum, setSerialNum] = useState("");

    useEffect(() => {
        UpdateDeviceInfo();
    }, [])

    function UpdateDeviceInfo() {
        setIsLoading(true);
        DeviceService.GetDeviceInfo()
            .then((response) => {
                setDeviceList(response.response);
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            })
    }

    function DeActivateHandler() {
        setIsLoading(true);
        DeviceService.ActivateDeactivateDevice(serialNum, false)
            .then((response) => {
                setIsLoading(false);
                UpdateDeviceInfo();
            })
            .catch(() => {
                setIsLoading(false);
            });
        setDeactivatePopup(false);
    }

    function ActivateHandler() {
        setIsLoading(true);
        DeviceService.ActivateDeactivateDevice(serialNum, true)
            .then((response) => {
                setIsLoading(false);
                UpdateDeviceInfo();
            })
            .catch(() => {
                setIsLoading(false);
            });
        setActivatePopup(false);
    }

    function activatePopupShowHandler(deviceSerialNum) {
        setActivatePopup(true);
        setSerialNum(deviceSerialNum);
    }

    function activatePopupCloseHandler() {
        setActivatePopup(false);
    }

    function deactivatePopupShowHandler(deviceSerialNum) {
        setDeactivatePopup(true);
        setSerialNum(deviceSerialNum);
    }

    function deactivatePopupCloseHandler() {
        setDeactivatePopup(false);
    }

    if (isLoading) {
        return (
            <div>
                <LoadingIndicator size="large" message="Fetching..." />
            </div>
        );
    }

    return (
        <>
            <h1>Device Details</h1>
            <div className="table-responsive">
                <table class="table">
                    <thead class="table-dark">
                        <tr>
                            <th scope="col">DeviceSerialNum</th>
                            <th scope="col">Status</th>
                            <th scope="col">Make</th>
                            <th scope="col">Model</th>
                            <th scope="col">CertGenerationDate</th>
                            <th scope="col">CertExpiryDate</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {deviceList.map(deviceInfo => (
                            <tr>
                                <td>
                                    {deviceInfo.DeviceSerialNum}
                                </td>
                                <td>
                                    {deviceInfo.Status}
                                </td>
                                <td>
                                    {deviceInfo.Make}
                                </td>
                                <td>
                                    {deviceInfo.Model}
                                </td>
                                <td>
                                    {deviceInfo.CertGenerationDate ? moment(deviceInfo.CertGenerationDate).format('DD-MMM-YYYY') : null}
                                </td>
                                <td>
                                    {deviceInfo.CertExpiryDate ? moment(deviceInfo.CertExpiryDate).format('DD-MMM-YYYY') : null}
                                </td>
                                <td>
                                    {deviceInfo.Status == "Active" ? <button className="btn btn-warning" onClick={() => deactivatePopupShowHandler(deviceInfo.DeviceSerialNum)} > DeActivate</button> : <button className="btn btn-success" onClick={() => activatePopupShowHandler(deviceInfo.DeviceSerialNum)}>Activate</button>}
                                    {activatePopup && <Popup popup={activatePopup} onClose={activatePopupCloseHandler} title="Activate" body="Do you want to Activate?" action="Yes" onAction={ActivateHandler} />}
                                    {deActivatePopup && <Popup popup={deActivatePopup} onClose={deactivatePopupCloseHandler} title="Deactivate" body="Do you want to Deactivate?" action="Yes" onAction={DeActivateHandler} />}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default Home;